import { RegulationPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { IDocumentsApiResponse } from "@nvb/ui";

/**
 * The documents come from the API, which the browser used to be the only one to
 * call — so the prerendered HTML said "no documents available". The build-time
 * snapshot travels in `pageContext.initialData` (see `pages/+onBeforeRender.ts`)
 * and seeds the hook; the page still refetches on mount.
 */
export default function Page() {
	const { initialData } = usePageContext();
	const documents = initialData?.documents as IDocumentsApiResponse | undefined;

	return <RegulationPage {...(documents ? { initialDocuments: documents } : {})} />;
}
